<template>
  <div class="row" style="padding-left: 87px">
    <div style="margin: 15px 180px 5px 123px">
      <button
        data-test-id="button-adicionarencaixe-1"
        class="btn btn-primary btn-block"
        @click="adicionarEncaixe(agendas)"
      >
        <span class="fa fa-plus" /> Adicionar
      </button>
    </div>
    <br />
    <div v-for="agenda in agendas" :key="agenda._id">
      <span v-for="agendamento in agenda.agendamentos" :key="agendamento._id">
        <div
          v-if="agendamento.encaixe"
          class="col-xs-6 col-sm-4 col-md-3 col-lg-3 encaixe"
        >
          <AgendamentoFicha
            :agendamento="agendamento"
            :data="data"
            :hora="agendamento.hora"
            :especialidade="especialidade"
            :unidade="unidade"
            :encaixe="true"
            class="agendamento_ficha"
            @atualizar="atualizar"
            @atualizarAgendamento="atualizarAgendamento"
          />
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import STATUS_AGENDAMENTO from '@/constantes/dominio/STATUS_AGENDAMENTO'

import AgendamentoFicha from './AgendamentoFicha'

export default {
  name: 'EncaixeAgendamento',
  components: { AgendamentoFicha },
  props: {
    agendas: {
      type: Array,
      required: true,
    },
    data: {
      type: String,
      required: true,
    },
    unidade: {
      type: String,
      required: true,
    },
    especialidade: {
      type: String,
      required: true,
    },
  },
  methods: {
    adicionarEncaixe(agendas) {
      const agenda = agendas.find((agenda) => agenda.encaixe)
      const agendamento = {
        data: '',
        guia: {},
        encaixe: true,
        paciente: {
          nome: '',
          telefone: '',
          preAgendamento: false,
          valido: false,
          convenio: {},
        },
        hora: '',
        profissional: {},
        style: '',
        status: '',
        statusAtual: '',
        statusAgendamentoSeguintes: [
          STATUS_AGENDAMENTO.valores.find((x) => x.id === 'marcado'),
        ],
        unidade: '',
        especialidade: '',
      }
      if (agenda) {
        agenda.quantidade = agenda.quantidade + 1
        agenda.agendamentos.push(agendamento)
      } else {
        agendas.push({
          agendamentos: [agendamento],
          quantidade: 1,
          encaixe: true,
        })
      }
    },
    atualizar() {
      this.$emit('atualizar')
    },
    atualizarAgendamento(agendamento) {
      this.$emit('atualizarAgendamento', agendamento)
    },
  },
}
</script>
